module.exports = __webpack_public_path__ + "static/img/undefined.377ff551.png";